import axios from "axios";
import { Loading } from "element-ui";
import { ACCESS_TOKEN, } from '@/config/constants'
import router from '@/router/index'

// 当前接口请求数
let requestNum = 0;
let loadingInstance;

const service = axios.create({
    baseURL: 'http://api.bailaohuimin.cn', // 公共请求地址
    // baseURL: window.location.protocol+'//'+window.location.host, // 公共请求地址
    // baseURL: window.location.protocol + '//' + window.location.hostname, // 公共请求地址
    timeout: 100000, // 请求超时时间
})

// // 请求拦截器
service.interceptors.request.use((config) => {
    // Vue.ls本地储存token
    const token = localStorage.getItem('Authorization')
    if (token) {
        // 添加token请求头
        config.headers[ACCESS_TOKEN] = token
    }
	if (requestNum <= 0) {
	  // 打开加载动画
	  loadingInstance = Loading.service({
	    lock: true,
	    text: "正在加载",
	    spinner: "el-icon-loading",
	    background: "rgba(0, 0, 0, 0.7)",
	  });
	}
	requestNum += 1;
    return config
}, error => Promise.reject(error))
service.interceptors.response.use(
    response => {
		requestNum = requestNum - 1;
		    if (requestNum <= 0) {
		      // 关闭加载动画
		      loadingInstance.close();
		    }
        let res = response.data;
        if (res.code === '401') {
            // this.$message.error("登录已过期，请重新登录！");
            localStorage.clear() // 移除token，跳转至登录
            router.push("/")
        }
        // 如果是返回的文件
        if (response.config.responseType === 'blob') {
            return res
        }
        // 兼容服务端返回的字符串数据
        if (typeof res === 'string') {
            res = res ? JSON.parse(res) : res
        }
        return res;
    },
    error => {
		requestNum = requestNum - 1;
		    if (requestNum <= 0) {
		      // 关闭加载动画
		      loadingInstance.close();
		    }
        let res = error.response.data;
        if (res.code == '401') {
            // this.$message.error("登录已过期，请重新登录！");
            localStorage.clear() // 移除token，跳转至登录
            
            router.push("/")
        }
        // console.log('err' + error) // for debug
        return Promise.reject(error)
    }
)

service.interceptors.response.use((response) => {
    return response
    // if (response.status && response.status === 200) {
    //     // 通讯成功
    //     if (response.code === 1) {
    //         return response
    //     } else if (response.code === 401) {
    //         // 如果是token过期，跳转至登录
    //         this.$message.error("登录已过期，请重新登录！");
    //         localStorage.removeItem('token') // 移除token，跳转至登录
    //         router.push({
    //             path: '/Login'
    //         })
    //     }
    //     return Promise.resolve(response.data)
    // }
})

export { service as axios }